import { FunctionComponent, PropsWithChildren } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { Ordinal } from '@sorare/core/src/atoms/typography/Ordinal';
import {
  Bronze,
  Gold,
  Silver,
} from '@sorare/core/src/components/club/Trophies';
import { WithRewardRange } from '@sorare/core/src/lib/rewards';

const StyledBodyM = styled(BodyM)`
  line-height: 1;
`;

const StyledSup = styled.sup`
  font-size: var(--fs-12);
`;

const TROPHY_ICONS: {
  [key: number]: FunctionComponent<PropsWithChildren>;
} = {
  1: Gold,
  2: Silver,
  3: Bronze,
};

type Props = WithRewardRange<object>;

export const RankRewardTitle = ({
  startRank,
  endRank,
  startPct,
  endPct,
}: Props) => {
  const start = startRank ?? (startPct || 0);
  const end = endRank ?? (endPct || 0);

  const TrophyComponent = TROPHY_ICONS[start];

  return (
    <>
      {start === end ? (
        <Horizontal>
          {TrophyComponent && <TrophyComponent />}
          <StyledBodyM as="p" bold>
            <FormattedMessage
              id="PrizePoolLeaderboard.RankRewards.ordinalPlace"
              defaultMessage="{ordinal} place"
              values={{
                ordinal: <Ordinal ordinal={start} Sup={StyledSup} />,
              }}
            />
          </StyledBodyM>
        </Horizontal>
      ) : (
        <Horizontal gap={1}>
          <StyledBodyM as="p" bold>
            {startRank ? (
              <Ordinal ordinal={start} Sup={StyledSup} />
            ) : (
              <FormattedNumber value={start} style="percent" />
            )}
          </StyledBodyM>
          <StyledBodyM as="p" bold>
            →
          </StyledBodyM>
          <StyledBodyM as="p" bold>
            {endRank ? (
              <Ordinal ordinal={end} Sup={StyledSup} />
            ) : (
              <FormattedNumber value={end} style="percent" />
            )}
          </StyledBodyM>
        </Horizontal>
      )}
    </>
  );
};
